export interface IQuickReplyTemplate {
  id: string;
  name: string;
  body: string;
  dateUpdated: Date;
}

/** Поля формы create/update и prefill (без id / dateUpdated). */
export type QuickReplyTemplateData = {
  name: string;
  body: string;
};

export const QUICK_REPLY_TEMPLATE_NAME_MAX_LENGTH = 200;
export const QUICK_REPLY_TEMPLATE_BODY_MAX_LENGTH = 4096;
